import { useViewMode } from '../../../hooks/use-view-mode';

interface SidebarProps {
  children: React.ReactNode | React.ReactNode[];
}

export default function Sidebar({ children }: SidebarProps) {
  const { viewMode, heightMode } = useViewMode();
  const isSmall = viewMode === 'Phone';
  const isShort = heightMode === 'Short';
  const isMedium = heightMode === 'Medium';

  return (
    <nav
      style={{
        color: 'white',
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        backgroundColor: '#004763',
        display: 'flex',
        flex: '80px',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 2,
        ...(isSmall && {
          display: 'block',
          overflow: 'initial',
          padding: '24px 16px'
        }),
        ...(isShort && {
          flex: '50px'
        }),
        ...(isMedium && {
          flex: '60px'
        })
      }}
    >
      {children}
    </nav>
  );
}
